// Code review - Completed
// Documentation - Completed
import { useEffect, useState } from "react";
import { mainTable } from "../css/Common";
import InputText from "../ReusableComponents/InputText";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import DropDown from "../ReusableComponents/DropDown";
import TextArea from "../ReusableComponents/TextArea";
import { BindAPI, BindPostAPI } from "../services/APIConnection";
import UsePrevious from "../Hook/UsePrevious";

const LaundryReceiptPopup = ({ data, data1 }) => {
    
    const [bindLaundryCompanies, setBindLaundryCompanies] = useState([]);
    const [bindItemType, setBindItemType] = useState([]);
    const [bindItemCategory, setBindItemCategory] = useState([]);
    const [bindItem, setBindItem] = useState([]);
    const mstClientId = sessionStorage.getItem("MstClientId");
    const [date, setDate] = useState('');
    const [date1, setDate1] = useState('');

    const [tableData, setTableData] = useState([
        {
            MstItemTypeId: "",
            MstItemcategoryId: "",
            MstItemId: "",
            UOM: "",
            IssuedQuantity: "",
            ReceiptQuantity: "",
            Balance: "",
            ItemcategoryList: [],
            ItemList: []
        },
    ]);

    const previousTableData = UsePrevious(tableData);
    useEffect(() => {
        
        getLaundryCompaniesDatas();
        getItemTypeDatas();
        getItemCategoryDatas();
        getItemDatas();

        if (data.length != 0) {
            const currentDate = data?.Date;

            const formattedDate = currentDate.split("T")[0];
            setDate(formattedDate)

            const currentDate1 = data?.IssueDate;

            const formattedDate1 = currentDate1.split("T")[0];
            setDate1(formattedDate1)
        }
        if (data1.length != 0) {

            appendDataToCommoditiesTable1(JSON.stringify(data1))
        } else {
            setTableData([
                ...tableData,
                {
                    MstItemTypeId: "",
                    MstItemcategoryId: "",
                    MstItemId: "",
                    UOM: "",
                    IssuedQuantity: "",
                    ReceiptQuantity: "",
                    Balance: "",
                    ItemcategoryList: [],
                    ItemList: []
                },
            ]);
        }
    }, [data]);

    const getLaundryCompaniesDatas = async () => {
        const data = {
            mstClientId: mstClientId,
        };
        const response = await BindPostAPI(data, "LaundryMasterAPI/BindLaundryCompany");
        const getLaundryCompanies =
            response.data.Table && response.data.Table.length > 0
                ? response.data.Table.map((item) => ({
                    value: item.MstLaundryCompanyId,
                    label: item.LaundryCompany,
                }))
                : [];
        setBindLaundryCompanies(getLaundryCompanies);
    };
    const getItemTypeDatas = async () => {

        const response = await BindAPI("ItemsAPI/BindItemType");
        const getLaundryCompanies =
            response.data.Table && response.data.Table.length > 0
                ? response.data.Table.map((item) => ({
                    value: item.MstItemTypeId,
                    label: item.ItemType,
                }))
                : [];
        setBindItemType(getLaundryCompanies);
    };

    const getItemCategoryDatas = async () => {
        const data = {
            mstClientId: mstClientId,
        };
        const response = await BindPostAPI(data, "ItemscategoryAPI/Binditemscategory");

        setBindItemCategory(response.data.Table);
    };

    const getItemDatas = async () => {
        const data = {
            mstClientId: mstClientId,
        };
        const response = await BindPostAPI(data, "ItemsAPI/BindItems");

        setBindItem(response.data.Table);
    };

    const handleDeleteRow = (index) => {
        const updated = [...tableData];
        updated.splice(index, 1);
        setTableData(updated);
    };

    const appendDataToCommoditiesTable1 = (newDataString) => {
        
        const newDataArray = JSON.parse(newDataString);
        handleDeleteRow(0);
        setTableData([]);
        const formattedDataArray = newDataArray.map((data) => {

            return {
                MstItemTypeId: data.MstItemTypeId,
                MstItemcategoryId: data.MstItemcategoryId,
                MstItemId: data.MstItemId,
                UOM: data.UOM,
                IssuedQuantity: data.IssuedQuantity,
                ReceiptQuantity: data.ReceivedQuantity,
                Balance: data.Balance,

            };
        });

        setTableData((prevData) => [...prevData, ...formattedDataArray]);
        updateTableData1(formattedDataArray);

    };


    const updateTableData1 = async (formattedDataArray) => {

        if (JSON.stringify(previousTableData) !== JSON.stringify(formattedDataArray)) {
            const updatedTableData = [...formattedDataArray]; // Clone the current table data

            // Iterate through each row
            for (const row of updatedTableData) {
                if (row?.MstItemTypeId) {
                    const getFilteredCategory = bindItemCategory
                        .filter(
                            (item) => item.MstItemTypeId === row.MstItemTypeId
                        )
                        .map((item) => ({
                            value: item.MstItemCategoryId,
                            label: item.ItemCategory,
                        }));
                    row.ItemcategoryList = getFilteredCategory;
                }

                if (row?.MstItemcategoryId) {
                    const selectedCategory = bindItem
                        .filter(
                            (item) => item.MstItemCategoryId === row.MstItemcategoryId
                        )
                        .map((item) => ({
                            value: item.MstItemId,
                            label: item.ItemName,
                            uom: item.UOM,
                        }));
                    row.ItemList = selectedCategory;

                    // Find the selected commodity for the row and set its unit of measure
                    const selectedCommodity = selectedCategory.find(
                        (item) => item.value === row.MstItemId
                    );
                    row.UOM = selectedCommodity?.uom || ""; // Reset if no selected commodity
                }

            }

            setTableData(updatedTableData);
        }
    };



    return (
        <div class="w-full ">
            <div className={mainTable.addShadowScreen}>
                <div className={mainTable.mainContentScreen}>
                    <form className={mainTable.formForClientMaster}>
                        <div className={mainTable.grid3}>
                            <InputText
                                title="Receipt No"
                                name="receiptNo"
                                placeholder="Receipt No"
                                disabled={true}
                                // tabIndex="1"
                                content={data?.ReceiptNo}
                            />

                            <InputText
                                inputType="date"
                                title="Received Date"
                                classStar="text-red-500"
                                disabled={true}
                                name="date"
                                content={date}

                                // tabIndex="1"
                            />

                            <DropDown
                                title="Received From"
                                name="receivedFrom"
                                disabled={true}
                                classStar="text-red-500"
                                selectedOption={data?.MstLaundryCompanyId}
                                options={bindLaundryCompanies}

                                // tabIndex="1"
                            />

                            <InputText
                                inputType="text"
                                title="Received By"
                                name="receivedBy"
                                disabled={true}
                                content={data?.ReceivedBy}

                            />

                            <InputText
                                inputType="text"
                                title="Issue No"
                                name="issueNo"
                                classStar="text-red-500"
                                disabled={true}
                                content={data?.IssueNo}
                                // tabIndex="1"
                            />

                            <InputText
                                inputType="date"
                                title="Issue Date"
                                classStar="text-red-500"
                                name="date"
                                content={date1}
                                disabled={true}
                                // tabIndex="1"
                            />
                        </div>

                       
                        <table className="min-w-full border border-gray-300">
                           <thead className="bg-[#3D6643] text-white sticky top-0 z-10 ">
                                <tr>
                                    <th className="border px-2 py-2 w-[30px]">S.No</th>
                                    <th className="border px-4 py-2 w-[180px]">Item Type</th>
                                    <th className="border px-4 py-2 w-[180px]">Category</th>
                                    <th className="border px-4 py-2 w-[180px]">Name</th>
                                    <th className="border px-4 py-2 w-[80px]">U.O.M</th>
                                    <th className="border px-4 py-2 w-[80px]">
                                        Issued Quantity
                                    </th>
                                    <th className="border px-4 py-2 w-[80px]">
                                        Received Quantity
                                    </th>
                                    <th className="border px-4 py-2 w-[80px]">Balance</th>
                                </tr>
                            </thead>
                            <tbody>
                                {tableData.map((row, index) => (
                                    <tr key={index}>
                                        <td className="border px-2 py-2 w-[30px]">
                                            {index + 1}
                                        </td>

                                        <td className="border px-4 py-2">
                                            <AutoDropDown
                                                options={bindItemType}
                                                placeholder="Select"
                                                name="MstItemTypeId"
                                                Class="p-0"
                                                disabled={true}
                                                selectedOption={bindItemType.find(
                                                    (x) => x.value == row.MstItemTypeId
                                                )}

                                            />
                                        </td>
                                        <td className="border px-4 py-2">
                                            <AutoDropDown
                                                options={row.ItemcategoryList || []}
                                                placeholder="Select"
                                                name="MstItemcategoryId"
                                                disabled={true}
                                                Class="p-0"
                                                selectedOption={row.ItemcategoryList?.find(
                                                    (x) => x.value === row.MstItemcategoryId
                                                )}

                                            />
                                        </td>
                                        <td className="border px-4 py-2">
                                            <AutoDropDown
                                                options={row.ItemList || []}
                                                placeholder="Select"
                                                name="MstItemId"
                                                disabled={true}
                                                Class="p-0"
                                                selectedOption={row.ItemList?.find(
                                                    (x) => x.value === row.MstItemId
                                                )}

                                            />
                                        </td>

                                        <td className="border px-4 py-2">
                                            <InputText
                                                type="text"
                                                content={row.UOM}
                                                maxLength={10}
                                                disabled={true}

                                            />
                                        </td>
                                        <td className="border px-4 py-2">
                                            <InputText
                                                type="text"
                                                content={row.IssuedQuantity}
                                                maxLength={5}
                                                disabled={true}

                                            />
                                        </td>
                                        <td className="border px-4 py-2">
                                            <InputText
                                                type="text"
                                                content={row.ReceiptQuantity}
                                                maxLength={5}
                                                disabled={true}

                                            />
                                        </td>
                                        <td className="border px-4 py-2">
                                            <InputText
                                                type="text"
                                                content={row.Balance}
                                                maxLength={5}
                                                disabled={true}

                                            />
                                        </td>

                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        <br />

                        <TextArea
                            title="Remarks"
                            name="remarks"
                            placeholder="Remarks"
                            // tabIndex="1"
                            maxLength={500}
                            rows={4}
                            disabled={true}
                            content={data?.Remarks}

                        />


                    </form>
                </div>
            </div>
        </div>
    );
};

export default LaundryReceiptPopup;
